
// object type check;
const _ = {};

_.curryr = fn => (...args) => {
  const a = args[0];
  const b = args[1];
  return args.length == 2 ? fn(a, b) : b => fn(b, a);
};

/**
 * [ object의 해당 key의 value를 반환 ]
 * @param  {[ojbect]} obj [ object ]
 * @param  {[String]} key [ object의 key]
 * @return {[String]} [ 해당 key의 value ]
 */
_.get = _.curryr((obj, key) => (obj == null ? undefined : obj[key]));

/**
 * [ object check ]
 * @param  {[object]} obj [ object ]
 * @return {[boolean]} [ type이 object이면 true ]
 */
_.is_object = obj => typeof obj == 'object' && !!obj;

/**
 * [ object key를 Array로 반환 ]
 * @param  {[object ]} obj [ object ]
 * @return {[Array]} [ object의 key들을 array로 반환 ]
 */
_.keys = obj => (_.is_object(obj) ? Object.keys(obj) : []);

/**
 * [ 자신이 받았던 첫번째 인자를 그대로 리턴 ]
 * @param  {[Array, object]} list [ Array, object ]
 * @param  {[Function]} iter [ object ]
 */
_.each = (list, iter) => {
  var keys = _.keys(list);
  for (var i = 0, len = keys.length; i < len; i++) {
    iter(list[keys[i]], keys[i]);
  }
};

_.filter = (list, predi) => {
  let new_list = [];
  _.each(list, (val) => {
    if (predi(val)) new_list.push(val);
  });
  return new_list;
};

_.map = (list, mapper) => {
  var new_list = [];
  _.each(list, (val, key) => {
    new_list.push(mapper(val, key));
  });
  return new_list;
};

_.find = _.curryr((list, predi) => {
  const keys = _.keys(list);
  for (let i = 0, len = keys.length; i < len; i++) {
    const val = list[keys[i]];
    if (predi(val)) return val;
  }
});

_.find_index = _.curryr((list, predi) => {
  let keys = _.keys(list);
  for (let i = 0, len = keys.length; i < len; i++) {
    if (predi(list[keys[i]])) return i;
  }
  return -1;
});

_.slice = (list, s, e) => list.slice(s, e);
export default _;
